import { z } from "zod";

export const patchFacilitySchema = z.object({
  name: z.string().min(1, { message: "Obligatoriskt fält" }),
  documentationEmail: z
    .string()
    .nullable()
    .transform((val) => {
      if (!val) return val;
      return val.replace(/\s+/g, "");
    })
    .pipe(
      z
        .string()
        .email({
          message: "Fältet måste vara en giltig epost-adress",
        })
        .nullish()
        .optional()
        .or(z.literal("")),
    ),
  address: z.string().nullable().optional(),
  postalCode: z
    .union([z.string(), z.null(), z.undefined()])
    .transform((val) => {
      if (val === null || val === undefined) return "";
      return val.trim().replace(/\s+/g, "");
    })
    .pipe(
      z
        .string()
        .refine((val) => val === "" || /^\d{5}$/.test(val), {
          message: "Ange ett giltigt postnummer utan mellanslag",
        })
        .optional(),
    ),
  city: z
    .union([z.string(), z.null()])
    .transform((val) => {
      if (val === null) return "";
      return val.trim();
    })
    .pipe(z.string().optional()),
  kommunKod: z
    .union([z.string(), z.null(), z.undefined()])
    .transform((val) => {
      if (val === null || val === undefined) return "";
      return val.replace(/\s+/g, "");
    })
    .pipe(
      z
        .string()
        .refine((val) => val === "" || /^\d{4}$/.test(val), {
          message: "Kommunkod måste vara exakt fyra siffror",
        })
        .optional(),
    ),
  cfarNr: z
    .string()
    .transform((val) => val.replace(/\s+/g, ""))
    .pipe(
      z
        .union([
          z.string().regex(/^\d+$/, {
            message: "CFAR nummer får bara innehålla siffror",
          }),
          z.string().refine((val) => val === "", {
            message: "CFAR nummer får bara innehålla siffror",
          }),
        ])
        .optional(),
    ),
  contactName: z
    .union([z.string(), z.null()])
    .transform((val) => {
      if (val === null) return "";
      return val.trim();
    })
    .pipe(z.string().optional()),
  contactEmail: z
    .union([z.string(), z.null()])
    .transform((val) => {
      if (val === null) return "";
      return val.replace(/\s+/g, "");
    })
    .pipe(
      z
        .union([
          z.string().email({
            message: "Fältet måste vara en giltig epost-adress",
          }),
          z.string().refine((val) => val === "", {
            message: "Fältet måste vara en giltig epost-adress",
          }),
        ])
        .optional(),
    ),
  notes: z.string().nullable().optional(),
  coordinates: z
    .union([z.string(), z.null(), z.undefined()])
    .transform((val) => {
      if (val === null || val === undefined) return "";
      return val.trim();
    })
    .pipe(
      z
        .string()
        .refine(
          (val) => val === "" || /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/.test(val),
          {
            message: "Koordinater måste vara i formatet 'lat,lon' (t.ex. 59.3293,18.0686)",
          }
        )
        .optional()
    ),
  contactPhone: z
    .union([z.string(), z.null()])
    .transform((val) => {
      if (val === null) return "";
      return val.replace(/\s+/g, "");
    })
    .pipe(
      z
        .union([
          z.string().regex(/^[\d\s+-]+$/, {
            message: "Ange ett giltigt telefonnummer",
          }),
          z.string().refine((val) => val === "", {
            message: "Ange ett giltigt telefonnummer",
          }),
        ])
        .optional(),
    ),
});

export type TPatchFacility = z.infer<typeof patchFacilitySchema>;
